import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const JobTitle = ({ jobType }) => {
  if (jobType === "hk") {
    return (
      <>
        <UpperCase>{jobType}</UpperCase>
      </>
    );
  }
  return (
    <>
      <Capitalize>{jobType}</Capitalize>
    </>
  );
};

JobTitle.propTypes = {
  jobType: PropTypes.string,
};

const Capitalize = styled.span`
  text-transform: capitalize;
`;

const UpperCase = styled.span`
  text-transform: uppercase;
`;

export default JobTitle;
